const STATE_NAME_TO_CODE: Record<string, string> = {
  ALABAMA: 'AL',
  ALASKA: 'AK',
  ARIZONA: 'AZ',
  ARKANSAS: 'AR',
  CALIFORNIA: 'CA',
  COLORADO: 'CO',
  CONNECTICUT: 'CT',
  DELAWARE: 'DE',
  FLORIDA: 'FL',
  GEORGIA: 'GA',
  HAWAII: 'HI',
  IDAHO: 'ID',
  ILLINOIS: 'IL',
  INDIANA: 'IN',
  IOWA: 'IA',
  KANSAS: 'KS',
  KENTUCKY: 'KY',
  LOUISIANA: 'LA',
  MAINE: 'ME',
  MARYLAND: 'MD',
  MASSACHUSETTS: 'MA',
  MICHIGAN: 'MI',
  MINNESOTA: 'MN',
  MISSISSIPPI: 'MS',
  MISSOURI: 'MO',
  MONTANA: 'MT',
  NEBRASKA: 'NE',
  NEVADA: 'NV',
  'NEW HAMPSHIRE': 'NH',
  'NEW JERSEY': 'NJ',
  'NEW MEXICO': 'NM',
  'NEW YORK': 'NY',
  'NORTH CAROLINA': 'NC',
  'NORTH DAKOTA': 'ND',
  OHIO: 'OH',
  OKLAHOMA: 'OK',
  OREGON: 'OR',
  PENNSYLVANIA: 'PA',
  'RHODE ISLAND': 'RI',
  'SOUTH CAROLINA': 'SC',
  'SOUTH DAKOTA': 'SD',
  TENNESSEE: 'TN',
  TEXAS: 'TX',
  UTAH: 'UT',
  VERMONT: 'VT',
  VIRGINIA: 'VA',
  WASHINGTON: 'WA',
  'WEST VIRGINIA': 'WV',
  WISCONSIN: 'WI',
  WYOMING: 'WY',
  'DISTRICT OF COLUMBIA': 'DC'
}

const toTitleCase = (value: string) =>
  value
    .toLowerCase()
    .split(' ')
    .map(part => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(' ')

const STATE_CODE_TO_NAME: Record<string, string> = Object.fromEntries(
  Object.entries(STATE_NAME_TO_CODE).map(([stateName, code]) => [code, toTitleCase(stateName)])
)

const STATE_NAMES = Object.keys(STATE_NAME_TO_CODE)
  .filter(stateName => stateName !== 'DISTRICT OF COLUMBIA')
  .map(toTitleCase)

export const licenseStates = STATE_NAMES.map(state => ({ label: state, value: state }))

export const normalizeStateCode = (value: string | null | undefined) => {
  const normalizedValue = value?.trim().toUpperCase() ?? ''

  if (!normalizedValue) {
    return ''
  }

  if (normalizedValue.length === 2) {
    return normalizedValue
  }

  return STATE_NAME_TO_CODE[normalizedValue] ?? normalizedValue
}

export const normalizeStateName = (value: string | null | undefined) => {
  const trimmedValue = value?.trim() ?? ''

  if (!trimmedValue) {
    return ''
  }

  const normalizedValue = trimmedValue.toUpperCase()

  if (normalizedValue.length === 2) {
    return STATE_CODE_TO_NAME[normalizedValue] ?? trimmedValue
  }

  return trimmedValue
}

export const isKnownUsState = (value: string | null | undefined) => {
  const normalizedCode = normalizeStateCode(value)
  return Boolean(normalizedCode && STATE_CODE_TO_NAME[normalizedCode])
}
